import React from 'react';
import _ from 'lodash';
import {Grid} from 'semantic-ui-react';
import {
  TextBoxField,
  RadioField,
  Checkbox,
  InlineMultiSelect,
} from 'app-ui-componentlibrary/dist/go/components/common/FormControls';
import {TextAreaFieldFrom as TextAreaField} from 'app-ui-componentlibrary';
import Tooltip from 'app-ui-componentlibrary/dist/componentLibrary/layout/Tooltip';
import {
  PRECALC_BENEFITS_OPTIONS,
  COST_EFFECTIVNESS_OPTION_PARTS,
} from 'go/components/dynamic/modules/projectSiteInventory/constants';
import {getOptionText} from 'go/components/dynamic/modules/projectSiteInventory/utils';
const defaultSelected = {
  text: 'Select',
  value: null,
  key: 'select-default',
};

export class CostEffectivenessInformation extends React.Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  render() {
    if (this.props.inventoryItem === undefined) return <p>No data available</p>;
    if (!this.props.inventoryItem.payload) return <p>No data available</p>;
    if (!this.props.inventoryItem.payload.costEffectiveness)
      return <p>No data available</p>;
    const {displayType, options, includeNatureBasedSolutions} = this.props;
    const {costEffectiveness} = this.props.inventoryItem.payload;

    const formOptions = {
      readOnly: displayType === 'view',
    };
    const costEffectivenessOptionsParts = _.chain(_.get(options, 'benefitCostTypes', []))
      .sortBy('displayOrder')
      .reduce((result, option) => {
        const {text, value, displayOrder} = option;
        _.each(_.keys(COST_EFFECTIVNESS_OPTION_PARTS), (key) => {
          if (_.includes(_.get(COST_EFFECTIVNESS_OPTION_PARTS, key), displayOrder)) {
            if (result[key]) {
              result[key].push({
                label: text,
                value: value,
              });
            } else {
              result[key] = [
                {
                  label: text,
                  value: value,
                },
              ];
            }
          }
        });
        return result;
      }, {})
      .value();

    return (
      <div id="cost-effectiveness-information">
        <Grid>
          <Grid.Row>
            <Grid.Column mobile={16} computer={16}>
              <div id="cost-effectiveness-evaluated">
                <div className="util--full-width ui form">
                  {options && (
                    <React.Fragment>
                      <RadioField
                        guidance="How cost-effectiveness was determined?"
                        id="costEffectiveness"
                        name="payload.costEffectiveness.method"
                        value={_.get(costEffectiveness, 'method')}
                        handleChange={this.props.handleChange}
                        handleBlur={this.props.handleBlur}
                        options={_.get(costEffectivenessOptionsParts, 1)}
                        formOptions={formOptions}
                      />
                      <div className="precalc-benefits-options">
                        {costEffectiveness.method === 'CS' &&
                          _.map(PRECALC_BENEFITS_OPTIONS, (option, index) => {
                            return (
                              <Checkbox
                                key={option.name}
                                id={option.name}
                                title={option.text}
                                name={option.name}
                                label={option.text}
                                handleChange={this.props.handleNameValueChange}
                                handleBlur={this.props.handleBlur}
                                value={option.value}
                                checked={_.get(costEffectiveness, [
                                  'preCalcBenefits',
                                  option.value,
                                ])}
                                readOnly={displayType === 'view'}
                                displayError={this.props.displayError(
                                  'payload.costEffectiveness.preCalcBenefits'
                                )}
                                errorMessages={
                                  index + 1 === _.size(PRECALC_BENEFITS_OPTIONS)
                                    ? this.props.getErrorMessage(
                                        'payload.costEffectiveness.preCalcBenefits',
                                        'Please select at least one pre-calculated benefits options'
                                      )
                                    : ''
                                }
                              />
                            );
                          })}
                      </div>
                      <RadioField
                        id="costEffectiveness"
                        name="payload.costEffectiveness.method"
                        value={_.get(costEffectiveness, 'method')}
                        handleChange={this.props.handleChange}
                        handleBlur={this.props.handleBlur}
                        options={_.get(costEffectivenessOptionsParts, 2)}
                        formOptions={formOptions}
                      />
                      {costEffectiveness.method === 'OTHER' && (
                        <Grid.Row>
                          <Grid.Column mobile={16} computer={16}>
                            <div id="other-cost-effectiveness" className="indent_1">
                              {displayType === 'view' ? (
                                <React.Fragment>
                                  <p className="label">
                                    If 'other' cost-effectiveness, specify
                                  </p>
                                  {costEffectiveness.other}
                                </React.Fragment>
                              ) : (
                                <div className="util--full-width ui form">
                                  <TextAreaField
                                    maxLength={4001}
                                    id="other-cost-effectiveness-control"
                                    label="Please explain FEMA approved methodology used for cost-effectiveness"
                                    title="Please explain FEMA approved methodology used for cost-effectiveness"
                                    name="payload.costEffectiveness.other"
                                    value={costEffectiveness.other}
                                    handleChange={this.props.handleChange}
                                    handleBlur={this.props.handleBlur}
                                    displayError={this.props.displayError(
                                      'payload.costEffectiveness.other'
                                    )}
                                    errorMessages={this.props.getErrorMessage(
                                      'payload.costEffectiveness.other',
                                      'cost-effectiveness other'
                                    )}
                                  />
                                </div>
                              )}
                            </div>
                          </Grid.Column>
                        </Grid.Row>
                      )}
                      <RadioField
                        id="costEffectiveness"
                        name="payload.costEffectiveness.method"
                        value={_.get(costEffectiveness, 'method')}
                        handleChange={this.props.handleChange}
                        handleBlur={this.props.handleBlur}
                        displayError={this.props.displayError(
                          'payload.costEffectiveness.method'
                        )}
                        errorMessages={this.props.getErrorMessage(
                          'payload.costEffectiveness.method',
                          'cost-effectiveness method'
                        )}
                        options={_.get(costEffectivenessOptionsParts, 3)}
                        formOptions={formOptions}
                      />
                      {costEffectiveness.method === 'NA' && (
                        <Grid.Row>
                          <Grid.Column mobile={16} computer={16}>
                            <div id="other-cost-effectiveness" className="indent_1">
                              {displayType === 'view' ? (
                                <React.Fragment>
                                  <p className="label">
                                    Please explain why this project is not applicable
                                  </p>
                                  {costEffectiveness.explanation}
                                </React.Fragment>
                              ) : (
                                <div className="util--full-width ui form">
                                  <TextAreaField
                                    maxLength={4001}
                                    id="notApplicableaExplanation-cost-effectiveness-control"
                                    label="Please explain why cost-effectiveness is not applicable"
                                    title="Please explain why cost-effectiveness is not applicable"
                                    name="payload.costEffectiveness.explanation"
                                    value={_.get(costEffectiveness, 'explanation', '')}
                                    handleChange={this.props.handleChange}
                                    handleBlur={this.props.handleBlur}
                                    displayError={this.props.displayError(
                                      'payload.costEffectiveness.explanation'
                                    )}
                                    errorMessages={this.props.getErrorMessage(
                                      'payload.costEffectiveness.explanation',
                                      'not applicable explanation'
                                    )}
                                  />
                                </div>
                              )}
                            </div>
                          </Grid.Column>
                        </Grid.Row>
                      )}
                    </React.Fragment>
                  )}
                </div>
              </div>
            </Grid.Column>
          </Grid.Row>
          {costEffectiveness.method != 'NA' && (
            <Grid.Row>
              <Grid.Column mobile={6} computer={6}>
                <div id="benefit-cost-ratio">
                  {displayType === 'view' ? (
                    <React.Fragment>
                      <p className="label">Benefit-cost ratio (BCR)</p>
                      {costEffectiveness.benefitCostRatio}
                    </React.Fragment>
                  ) : (
                    <div className="util--full-width ui form">
                      <TextBoxField
                        id="benefit-cost-ratio-control"
                        label="Benefit-cost ratio (BCR)"
                        title="Required: Benefit-cost ratio (BCR)"
                        name="payload.costEffectiveness.benefitCostRatio"
                        value={costEffectiveness.benefitCostRatio}
                        handleChange={this.props.saveBenefitCostRatio}
                        handleBlur={this.props.handleBlur}
                        displayError={this.props.displayError(
                          'payload.costEffectiveness.benefitCostRatio'
                        )}
                        errorMessages={this.props.getErrorMessage(
                          'payload.costEffectiveness.benefitCostRatio',
                          'Benefit-cost ratio (BCR)'
                        )}
                      />
                    </div>
                  )}
                </div>
              </Grid.Column>
            </Grid.Row>
          )}
          {costEffectiveness.method != 'NA' && includeNatureBasedSolutions && (
            <Grid.Row>
              <Grid.Column mobile={16} computer={16}>
                <div id="nature-based-solutions">
                  {displayType === 'view' ? (
                    <React.Fragment>
                      <Tooltip
                        htmlContent={''}
                        label={true}
                        input="nature-based-solutions-control"
                        popup={
                          ('Popup',
                          {
                            link:
                              'Did you incorporate Nature Based Solutions for this location? Please select the Nature Based Solution(s) used:',
                            text:
                              '<p>Please clearly include any cost or budget information for NBS elements in the additional comments section below.</p>',
                            style: {
                              borderRadius: 0,
                              opacity: 1,
                              padding: '5px',
                            },
                          })
                        }
                      ></Tooltip>
                      {getOptionText(
                        _.get(options, 'natureBasedSolutions', []),
                        costEffectiveness.natureBased
                      )}
                    </React.Fragment>
                  ) : (
                    <div className="util--full-width ui form">
                      <Tooltip
                        htmlContent={''}
                        label={true}
                        input="nature-based-solutions-control"
                        popup={
                          ('Popup',
                          {
                            link:
                              'Did you incorporate Nature Based Solutions for this location? Please select the Nature Based Solution(s) used:',
                            text:
                              '<p>Please clearly include any cost or budget information for NBS elements in the additional comments section below.</p>',
                            style: {
                              borderRadius: 0,
                              opacity: 1,
                              padding: '2em',
                            },
                          })
                        }
                      ></Tooltip>
                      <InlineMultiSelect
                        id="nature-based-solutions-control"
                        title="Required: Did you incorporate Nature Based Solutions for this location? Please select the Nature Based Solution(s) used:"
                        optional={false}
                        options={[..._.get(options, 'natureBasedSolutions', [])]}
                        name="payload.costEffectiveness.natureBased"
                        value={costEffectiveness.natureBased || []}
                        onChange={(e, data) =>
                          this.props.handleNameValueChange(
                            'payload.costEffectiveness.natureBased',
                            data.value
                          )
                        }
                        onBlur={this.props.handleMultiSelectBlur}
                        selectedLabel={null}
                        displayError={this.props.displayError(
                          'payload.costEffectiveness.natureBased'
                        )}
                        errorMessages={this.props.getErrorMessage(
                          'payload.costEffectiveness.natureBased',
                          'Did you incorporate Nature Based Solutions for this location? Please select the Nature Based Solution(s) used:'
                        )}
                      />
                    </div>
                  )}
                </div>
              </Grid.Column>
            </Grid.Row>
          )}
          {costEffectiveness.method != 'NA' &&
            includeNatureBasedSolutions &&
            _.includes(costEffectiveness.natureBased, 'OTHR') &&
            !_.includes(costEffectiveness.natureBased, 'NONE') && (
              <Grid.Row>
                <Grid.Column mobile={16} computer={16}>
                  <div id="other-nature-based-solutions" className="indent_1">
                    {displayType === 'view' ? (
                      <React.Fragment>
                        <p className="label">
                          If 'Other' Nature Based Solutions, specify
                        </p>
                        {costEffectiveness.natureBasedOther}
                      </React.Fragment>
                    ) : (
                      <div className="util--full-width ui form">
                        <TextAreaField
                          maxLength={4001}
                          id="other-nature-based-solutions-control"
                          label="Please explain other Nature Based Solutions incorporated for this location"
                          title="Please explain other Nature Based Solutions incorporated for this location"
                          name="payload.costEffectiveness.natureBasedOther"
                          value={costEffectiveness.natureBasedOther}
                          handleChange={this.props.handleChange}
                          handleBlur={this.props.handleBlur}
                          displayError={this.props.displayError(
                            'payload.costEffectiveness.natureBasedOther'
                          )}
                          errorMessages={this.props.getErrorMessage(
                            'payload.costEffectiveness.natureBasedOther',
                            'Other Nature Based Solutions'
                          )}
                        />
                      </div>
                    )}
                  </div>
                </Grid.Column>
              </Grid.Row>
            )}
        </Grid>
      </div>
    );
  }
}

export default CostEffectivenessInformation;
